import { ObservableValue, useMemo, useObservedValue, view } from '@esui/core';
import { Formatter } from '@esui/core/formatters';
import { html } from 'lit';

type Content<T> = T | ObservableValue<T>;

export const [Text] = view('esui-material-text', {
  Props: class TextProps {
    content: Content<unknown> = '';
    formatter: Formatter<unknown> = Formatter.default;
  },

  template({ content, formatter }) {
    const value = useObservedValue(content);
    const text = useMemo(() => formatter.format(value), [value]);

    return html`${text}`;
  },
  mapBuilder:
    TextBuilder =>
    <T>(content: Content<T>, formatter: Formatter<T> = Formatter.default) =>
      TextBuilder().content(content).formatter(formatter),
});

export * from './font.js';
